import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Header, Nav, HamburgerMenu, BtnSave } from './components'

import { 
    loginUserCheck, 
    logoutUser,
    promotionUpdateById
} from '../redux/actions'

class AdminEditPromotion extends Component {

    constructor(){
        super()
        this.state = {
            id: "",
            thumbnail: "",
            photo: "",
            oldThumbnail: null,
            oldPhoto: null,
            title: "",
            desc: "",
            sub_desc: "",
            toggleMenu: false
        }
    }

    componentWillMount() {
        this.props.loginUserCheck()
        let params = this.getParams()
        this.setState({ 
            id: params.id,
            oldThumbnail: this.props.location.search.substring(35,187),
            oldPhoto: this.props.location.search.substring(194,346),
            title: params.title,
            desc: params.desc,
            sub_desc: params.sub_desc
        })
    }

    getParams() {
        const searchParams = new URLSearchParams(this.props.location.search);
        return {
            id: searchParams.get('id') || '',
            title: searchParams.get('title') || '',
            desc: searchParams.get('desc') || '',
            sub_desc: searchParams.get('sub_desc') || ''
        };
    }

    _handleMenu() {
        this.setState({ toggleMenu: !this.state.toggleMenu })
    }

    _handleLogout() {
        this.props.logoutUser()
    }
    
    _onHandleChange(event) {
        if(event.target.files) {
            this.setState({
                [event.target.name]: event.target.files[0]
            })
        } else {
            this.setState({
                [event.target.name]: event.target.value
            })
        }
    }

    _onSubmit() {
        const oldThumbnail = decodeURIComponent(this.state.oldThumbnail.substring(70,99))
        const oldPhoto = decodeURIComponent(this.state.oldPhoto.substring(70,99))
        const oldFiles = { oldThumbnail, oldPhoto }
        const { thumbnail, photo, title, desc, sub_desc } = this.state
        const data = {
            thumbnail,
            photo,
            title,
            desc,
            sub_desc,
            created_by: this.props.user
        }
        if(title && sub_desc) {
            this.props.promotionUpdateById(this.state.id, data, oldFiles)
        } else {
            alert("Please fill in a form...")
        }
    }

    render() {
        // console.log(this.state)
        if(!this.props.user) return  <div></div> 
        return (
            <div>
                <Header name={this.props.user} logout={() => this._handleLogout()}/>
                <div className="admin-editpromotion">
                    <Nav active="promotion"/>
                    <div className={(this.state.toggleMenu)? "content moveover": "content"}>
                        <div className="content-inner">
                            <HamburgerMenu onClick={()=>this._handleMenu()} />
                            <div className="title">
                                <h2>โปรโมชั่น : แก้ไขรายการ</h2>
                            </div>
                            <div className="info">
                                <div className="adjust">
                                    <form action="" className="photo">
                                        <div className="promotion-title">
                                            <p>Thumbnail โปรโมชั่น (308x237px)</p>
                                        </div>
                                        <div className="filename">
                                            <p>{this.state.thumbnail.name}</p>
                                        </div>
                                            <div className="photo-input">
                                            <input id="thumbnail" type="file" name="thumbnail" accept="image/*" hidden onChange={(event) => this._onHandleChange(event)}/>
                                            <label htmlFor="thumbnail">เลือกรูปภาพ</label>
                                        </div>
                                        <div className="oldphoto">
                                            <img src={this.state.oldThumbnail} alt="promotion"/>
                                        </div>
                                    </form><br/>
                                    <form action="" className="photo">
                                        <div className="promotion-title">
                                            <p>รูปภาพโปรโมชั่น (414x173px)</p>
                                        </div>
                                        <div className="filename">
                                            <p>{this.state.photo.name}</p>
                                        </div>
                                        <div className="photo-input">
                                            <input id="photo" type="file" name="photo" accept="image/*" hidden onChange={(event) => this._onHandleChange(event)}/>
                                            <label htmlFor="photo">เลือกรูปภาพ</label>
                                        </div>
                                        <div className="oldphoto">
                                            <img src={this.state.oldPhoto} alt="promotion"/>
                                        </div>
                                    </form>
                                    <form className="text">
                                        <div className="promotion-name">
                                            <p>ชื่อโปรโมชั่น</p>
                                            <input type="text" name="title" onChange={(event) => this._onHandleChange(event)} value={this.state.title}></input>
                                        </div>
                                        <div className="actual-price">
                                            <p>รายละเอียดย่อ</p>
                                            <input type="text" name="sub_desc" value={this.state.sub_desc} onChange={(event) => this._onHandleChange(event)}></input>
                                        </div>
                                        <div className="discount-price">
                                            <p>รายละเอียด</p>
                                            <textarea name="desc" value={this.state.desc} onChange={(event) => this._onHandleChange(event)} />
                                        </div>
                                    </form>
                                    <div className="btn-submit">
                                        {
                                            (this.props.loading) ?
                                            <p style={{textAlign: 'center'}}>Loading...</p>
                                            :  <BtnSave click={() => this._onSubmit()}/>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
 
const mapStateToProps = ({ auth, promotion }) => {
    return { 
        user: auth.user,
        loading: promotion.loading
    }
}
 
export default connect(mapStateToProps, { 
    loginUserCheck, logoutUser, promotionUpdateById
})(AdminEditPromotion)